
import React from 'react';
import { JUVCard } from '@/components/juv';
import { Dna, PlusCircle } from 'lucide-react';
import TreatmentTable from './TreatmentTable';

const PRPTreatmentsSection = () => {
  const faceTreatments = [
    {
      name: 'RF Microneedling with PRP (Face)',
      single: '$950',
      package: '$2,500',
      tooltip: 'Combines radiofrequency with PRP to boost collagen and heal skin'
    },
    {
      name: 'RF Microneedling with PRP (Face + Neck)',
      single: '$1,250',
      package: '$3,500'
    },
    {
      name: 'Microneedling with PRP',
      single: '$600',
      package: '$1,650'
    },
    {
      name: 'Under-Eye PRP Rejuvenation',
      single: '$475',
      package: '$1,299',
      tooltip: 'Targets dark circles, hollowness, and texture'
    }
  ];

  const hairTreatments = [
    {
      name: 'PRP Hair Restoration w/ Laser',
      single: '$799',
      package: '$1,499',
      tooltip: 'Combines PRP and laser for improved hair density'
    },
    {
      name: 'PRP Hair Restoration',
      single: '$599',
      package: '$1,499'
    }
  ];

  const addOns = [
    'Extra PRP Vial – $199',
    'SmoothEye Maintenance – $599 (2 for $999)',
    'RF Microneedling Maintenance – $899 (2 for $1,499)',
    'LipLase Maintenance – $299 (2 for $399)'
  ];

  return (
    <JUVCard
      title="💉 PRP + RF Treatments"
      icon={Dna}
      variant="glass"
      className="mb-8"
    >
      <div className="space-y-8">
        {/* Face + Skin Subsection */}
        <div>
          <h3 className="text-xl font-semibold text-juv-deep-chestnut mb-4">
            Face + Skin
          </h3>
          <TreatmentTable
            headers={['Treatment', 'Single', 'Package of 3']}
            treatments={faceTreatments}
            showTooltips={true}
          />
        </div>

        {/* Hair Restoration Subsection */}
        <div>
          <h3 className="text-xl font-semibold text-juv-deep-chestnut mb-4">
            Hair Restoration
          </h3>
          <TreatmentTable
            headers={['Treatment', 'Single', 'Package of 3']}
            treatments={hairTreatments}
            showTooltips={true}
          />
        </div>

        {/* Add-Ons Subsection */}
        <div>
          <div className="flex items-center gap-2 mb-4">
            <PlusCircle className="h-5 w-5 text-juv-terracotta" />
            <h3 className="text-xl font-semibold text-juv-deep-chestnut">
              Add-Ons
            </h3>
          </div>
          <ul className="space-y-2">
            {addOns.map((addOn, index) => (
              <li 
                key={index} 
                className="text-juv-deep-chestnut/80 p-3 bg-juv-soft-blush/30 rounded-lg"
              >
                {addOn}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </JUVCard>
  );
};

export default PRPTreatmentsSection;
